import EnableCheckboxRenderer from '../../../Components/BasicDataTable/EnableCheckboxRenderer';
import MandatoryCheckboxRenderer from '../../../Components/BasicDataTable/MandatoryCheckboxRenderer';
import CustomHeaderCheckbox from './CustomHeaderCheckbox';
export const loginInfo = [
    {
        enrollment_field: 'Email ID',
        enable: false, 
        mandatory: true, 
        disabled: false
    },
    {
        enrollment_field: 'User ID',
        enable: false, 
        mandatory: false, 
        disabled: false
    },
    {
        enrollment_field: 'Password',
        enable: true, 
        mandatory: true, 
        disabled: true
    },
];
export const businessInfo = [
    {
        enrollment_field: 'Business Legal Name',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Ownership Type',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Tax Identification Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Industry Type',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Category',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Annual Revenue',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Monthly Spend',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Years in Business',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Number of Employees',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Company Website',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Name on Card',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Phone on Card',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Address',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
];
export const businessOwnerInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Relationship to Company',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Work Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Mobile Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Address & Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: '(Home) Own or Rent',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Time at Current Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Previous Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },

];
export const employeeInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Purchase Credit Limit',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Cash Advance Limit',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Work Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Mobile Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },

    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,
        disabled: false
    },

];
 
export const documentationInfo = [
    {
        enrollment_field: 'Article of Incorporation/By-Laws',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Business Documentation',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Financial Documentation',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Employer Identification Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
]; 
export const additionalCardInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
];
export const accountInfo = [
    {
        enrollment_field: 'Shipping Method',
        enable: false,  
        mandatory: false,
        disabled: false
    },
];
export const business_loginInfo = [
    {
        enrollment_field: 'Email ID',
        enable: false, 
        mandatory: true, 
        disabled: false
    },
    {
        enrollment_field: 'User ID',
        enable: false, 
        mandatory: false, 
        disabled: false
    },
    {
        enrollment_field: 'Password',
        enable: true, 
        mandatory: true, 
        disabled: true
    },
];
export const business_businessInfo = [
    {
        enrollment_field: 'Business Legal Name',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Ownership Type',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Tax Identification Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Industry Type',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Category',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Annual Revenue',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Monthly Spend',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Years in Business',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Number of Employees',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Company Website',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Name on Card',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Business Phone on Card',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Address',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
];
export const business_businessOwnerInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Relationship to Company',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Work Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Mobile Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Address & Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: '(Home) Own or Rent',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Time at Current Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Previous Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },

];
export const business_employeeInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Purchase Credit Limit',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Cash Advance Limit',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Home Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Work Phone Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Mobile Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },

    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,
        disabled: false
    },

];
 
export const business_documentationInfo = [
    {
        enrollment_field: 'Article of Incorporation/By-Laws',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Business Documentation',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Financial Documentation',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Employer Identification Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
]; 
export const business_additionalCardInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,
        disabled: false
    },
];
export const business_accountInfo = [
    {
        enrollment_field: 'Shipping Method',
        enable: false,  
        mandatory: false,
        disabled: false
    },
];

export const consumer_loginInfo = [
    {
        enrollment_field: 'Email ID',
        enable: false, 
        mandatory: true, 
        disabled: false, 
    },
    {
        enrollment_field: 'User ID',
        enable: false, 
        mandatory: false, 
        disabled: false, 
    },
    {
        enrollment_field: 'Password',
        enable: true, 
        mandatory: true, 
        disabled: true, 
    },
];
export const consumer_personalInfo = [
    {
        enrollment_field: 'First Name',
        enable: false,  
        mandatory: false,  
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Last Name',
        enable: false,  
        mandatory: false,  
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Suffix',
        enable: false,  
        mandatory: false,  
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Date of Birth',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Gender',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Email Address',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Social Security Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Home Phone Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Work Phone Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Mobile Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Home Address & Number',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'City',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'State',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Country',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'ZIP',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: '(Home) Own or Rent',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Time at Current Address',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Previous Address',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Shipping Method',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
];
export const consumer_sourceOfIncomeInfo = [
    {
        enrollment_field: 'Occupation',
        enable: false,  
        mandatory: false,  
        disabled: false
    },
    {
        enrollment_field: 'Employment Status',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Current Employer',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Time at Current Employer',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gross Annual Income',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Monthly Expenses select',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Expected Monthly Purchase (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Expected Monthly Intl Purchase (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Expected Monthly Cash Advance (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Monthly Housing Payment select',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Gambling Activities (Yes/No) (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Enrolled In Drug Company (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Politically Exposed (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Owner Of High-Risk Company(Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    },
    {
        enrollment_field: 'Ties To Foreign Country (Web)',
        enable: false,  
        mandatory: false,
        disabled: false
    }, 
];
export const consumer_identification_details = [
    {
        enrollment_field: 'SSN (US Only)',
        enable: false, 
        mandatory: true, 
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Driving License',
        enable: false, 
        mandatory: false, 
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Foreign ID',
        enable: true, 
        mandatory: true, 
        disabled: true,
        deleteable: false,
    },
];
export const consumer_documentary_proof = [
    {
        enrollment_field: 'SSN (US Only)',
        enable: false, 
        mandatory: true, 
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Driving License',
        enable: false, 
        mandatory: false, 
        disabled: false,
        deleteable: false,
    },
    {
        enrollment_field: 'Foreign ID',
        enable: true, 
        mandatory: true, 
        disabled: true,
        deleteable: false,
    },
];
export const enrollment_Type = ["Manage enrollment outside i2c platform", "Manage enrollment through i2c platform"]
export const enrollment_Url_Type = ["Standard Nomenclature", "Custom URL"]
export const enrollment_Url_Platform = [
    { label: "C-Holder Mobile", value: "C-Holder Mobile" },
    { label: "C-Holder Website", value: "C-Holder Website" },
];
export const heading_enrollment_Url_Platform = [
    { label: "C-Holder Mobile", value: "C-Holder Mobile" },
    { label: "C-Holder Website", value: "C-Holder Website" },
];
export const heading_enrollment_url = [{
    label: "i2c standard URL",
    value: "i2c standard URL"
}, {
    label: "Use custom URL",
    value: "Custom URL"
}];
export const card_enrollment_card_account_type_data = [
    { label: "Virtual", value: "Virtual" },
    { label: "Plastic", value: "Plastic" },
    { label: "Both", value: "Both" },
];
export const consumer_credit_card_type_data = [
    { label: "Secured", value: "Secured" },
    { label: "Unsecured", value: "Unsecured" },
];
export const card_enrollment_agreement_type_for_common_toggle_data = [
    { label: "Accept Electronic Communication", value: "Accept Electronic Communication" },
    { label: "Terms & Conditions", value: "Terms & Conditions" },
    { label: "Both", value: "Both" },
]

export const card_enrollment_agreement_type_data = ["Use Customized Content", "Use External URL"];
export const fundOption = ["Bank Account (ACH microdeposits) (U.S.)", "Bank Account (Plaid) (U.S.)", "BECS (Australia)", "Credit/Debit Card"];
export const paymentGateway = ["WorldPay", "Veritrans 3G", "Vantiv", "Tabby", "QPay", "POLi Payments", "MafPay", "Gravty", "Gravty", "TSYS", "Cash Payments", "BeanStream",
    "Benefit", "BPAY Payments", "Electracash", "Paymark", "VISA Credit", "Fetch", "Trans First", "Interac", "CyberSource (AuthorizeNet)", "Other"];
export const shippingMethod = [
    { feature: 'Normal Shipment', alternativeMethod: '', enabled: false },
    { feature: 'Urgent Shipment', alternativeMethod: '', enabled: false },
    { feature: 'VIP Shipment', alternativeMethod: '', enabled: false },
    { feature: 'Other', alternativeMethod: '', enabled: false },
];
